import React from 'react';
import { i18n } from 'config/locales';

import { Summary, DateSummary } from 'components/Summary';
import { SUBSTANCE_USE, SUBSTANCE_USE_THC_CLEARANCE } from 'config/formSections/substanceUse';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';
import ThcClearanceUse from './ThcClearanceUse';

const sectionConfig = {
  key: SUBSTANCE_USE_THC_CLEARANCE.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_THC_CLEARANCE.name,
  storeKey: SUBSTANCE_USE_THC_CLEARANCE.storeKey,
};

export class ThcClearanceUses extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
  }

  update = (updateValues) => {
    this.props.onUpdate(this.storeKey, {
      UsedThc: this.props.UsedThc,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...updateValues,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateUsedThc = (values) => {
    this.update({
      UsedThc: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const range = DateSummary(o.InvolvementDates);
    const description = (o.Description || {}).value;

    return Summary({
      type: i18n.t('substance.pvq.thc.clearance.collection.itemType'),
      index,
      left: description,
      right: range,
      placeholder: i18n.t('substance.pvq.thc.clearance.collection.summary'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content thc-clearance-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_THC_CLEARANCE.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.thc.clearance')}</h1>
        <Branch
          attribute="UsedThc"
          name="UsedThc"
          label={i18n.t('substance.pvq.thc.heading.thcClearanceUses')}
          labelSize="h4"
          className="used-thc"
          {...this.props.UsedThc}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateUsedThc}
          scrollIntoView={this.props.scrollIntoView}
        />

        <Show when={this.props.UsedThc.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('substance.pvq.thc.clearance.collection.description')}
            appendTitle={i18n.t('substance.pvq.thc.clearance.collection.appendTitle')}
            appendLabel={i18n.t('substance.pvq.thc.clearance.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <ThcClearanceUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

ThcClearanceUses.defaultProps = {
  UsedThc: {},
  List: { items: [], branch: {} },
  Comments: {},
  SummaryComments: {},
  onError: (value, arr) => arr,
  section: 'substance',
  subsection: 'thc/clearance',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
  formType: '',

};

export default connectSubsection(ThcClearanceUses, sectionConfig);
